export default "__VITE_ASSET__Tp3TnAT$__"